import { render, staticRenderFns } from "./ccm-smartbook-study.vue?vue&type=template&id=6be2c765&"
import script from "./ccm-smartbook-study.vue?vue&type=script&lang=js&"
export * from "./ccm-smartbook-study.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports